import { render } from "./AdvTransfer.vue?vue&type=template&id=2c0ff712"
import script from "./AdvTransfer.vue?vue&type=script&lang=js"
export * from "./AdvTransfer.vue?vue&type=script&lang=js"

import "./AdvTransfer.vue?vue&type=style&index=0&id=2c0ff712&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__